import type { FileIconKey } from "@caliu/utils";
import type { IconId } from "@/components/ui/Icon";

/**
 * Maps the cross-platform `FileIconKey` (from `@caliu/utils` `fileIconForName`)
 * to an Espurna icon. Shared by the editor's file-attachment chip and the note
 * list's attachment chips so both render the same icon for a given file type.
 */
export const FILE_ICONS: Record<FileIconKey, IconId> = {
  pdf: "note",
  archive: "file-archive",
  audio: "file-audio",
  video: "file-video",
  image: "file-image",
  spreadsheet: "file-spreadsheet",
  presentation: "file-presentation",
  document: "note",
  code: "file-code",
  text: "note",
  file: "note-blank",
};
